import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SecurityService } from '../_services';
import * as SecurityActions from '../_actions/security';

@Injectable({
  providedIn: 'root',
})
export class SecurityEffects {
  loadSecurities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.loadSecurities),
      mergeMap(() =>
        this.securityService.getSecurities().pipe(
          map((securities) => SecurityActions.loadSecuritiesSuccess({ securities })),
          catchError((error) => of(SecurityActions.loadSecuritiesFailure({ error })))
        )
      )
    )
  );

  addSecurity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.addSecurity),
      mergeMap(({ security }) =>
        this.securityService.saveSecurity(security).pipe(
          map((savedSecurity) => SecurityActions.addSecuritySuccess({ security: savedSecurity })),
          catchError((error) => of(SecurityActions.addSecurityFailure({ error })))
        )
      )
    )
  );

  updateSecurity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.updateSecurity),
      mergeMap(({ security }) =>
        this.securityService.saveSecurity(security).pipe(
          map((updatedSecurity) =>
            SecurityActions.updateSecuritySuccess({ security: updatedSecurity })
          ),
          catchError((error) => of(SecurityActions.updateSecurityFailure({ error })))
        )
      )
    )
  );

  deleteSecurity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.deleteSecurity),
      mergeMap(({ id }) =>
        this.securityService.deleteSecurity(id).pipe(
          map(() => SecurityActions.deleteSecuritySuccess({ id })),
          catchError((error) => of(SecurityActions.deleteSecurityFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private securityService: SecurityService
  ) {}
}
